import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import "./steps.css";

import { NavLink, useNavigate } from "react-router-dom";

const ProofOfAddress = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const navigate = useNavigate();

  const steps = [
    { label: "1) Scanning Your Id", path: "/kyc-upload" },
    { label: "2) Liveness Check", path: "/liveness-check" },
    { label: "3) Proof of address", path: "/proof-of-address" },
    { label: "4) Phone verification", path: "/phone-verification" },
    { label: "5) Email verification", path: "/email-verification" },
  ];

  const currentStep = 3; // set per page

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 md:pt-30 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap pt-3 pb-5">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-12 text-center">
                  <div className="page-title-box">
                    <h2 className="title">Onboarding</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section  pt-65 pb-130">
          <div className="container" bis_skin_checked={1}>
            <div className="row clearfix" bis_skin_checked={1}>
              <div
                className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-center"
                bis_skin_checked={1}
              >
                <div className=" px-0 pb-0 mb-3" bis_skin_checked={1}>
                  <h2 className="mb-3" id="heading" style={{ color: "black" }}>
                    KYC Documents Upload
                  </h2>
                  <div className="row justify-content-center">
                    <div className="col-md-10 text-center">
                      <p className="mb-3 fs-5">
                        To complete your onboarding on our mobile app, we require a Photo ID, liveness check, proof of address, phone verification, and email verification. Identity verification takes just 2 minutes to complete.
                      </p>
                    </div>
                  </div>
                  {/*<div class="row justify-content-center">
                          <div class="col-4">

                              <button type="button" class="btn btn-primary video-btn2" data-bs-toggle="modal" data-src="https://www.youtube.com/embed/qceO0YPfcVo" data-bs-target="#myModal">
                                  <i class="fa fa-play"></i> Watch Explainer Video
                              </button>
                          </div>
                      </div>*/}
                  <div id="msform" bis_skin_checked={1}>
                    {/* progressbar */}
                    <div
                      style={{
                        width: "100%",
                        margin: "40px 0",
                      }}
                    >
                      {/* LINE */}
                      <div
                        style={{
                          position: "relative",
                          height: "2px",
                          background: "#000000",
                          top: "22px",
                          zIndex: 0,
                        }}
                      />

                      {/* STEPS */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",              // ✅ allows wrapping on mobile
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "16px",                   // ✅ spacing for small screens
                          position: "relative",
                          zIndex: 1,
                        }}
                      >
                        {steps.map((step, index) => {
                          const stepNumber = index + 1;
                          const isCompleted = stepNumber < currentStep;
                          const isActive = stepNumber === currentStep;

                          return (
                            <div
                              key={index}
                              onClick={() => navigate(step.path)}
                              style={{
                                flex: "1 1 120px",        // ✅ responsive width
                                textAlign: "center",
                                cursor: "pointer",
                                minWidth: "90px",
                              }}
                            >
                              {/* CIRCLE */}
                              <div
                                style={{
                                  width: "38px",
                                  height: "38px",
                                  margin: "0 auto",
                                  borderRadius: "50%",
                                  background: isCompleted || isActive ? "#000000" : "#fff",
                                  border: "2px solid #000000",
                                  color: isCompleted || isActive ? "#fff" : "#000000",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontSize: "16px",
                                  fontWeight: "bold",
                                  transition: "all 0.2s ease",
                                }}
                              >
                                ✓
                              </div>

                              {/* TEXT */}
                              <div
                                style={{
                                  marginTop: "8px",
                                  fontSize: "14px",
                                  fontWeight: isActive ? "700" : "600",
                                  color: "#000000",
                                  whiteSpace: "normal",     // ✅ text wraps
                                  lineHeight: "1.3",
                                }}
                              >
                                {step.label}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {/* fieldsets */}
                    <fieldset>
                      <div className="form-card" bis_skin_checked={1}>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <h4 className="mb-4">How To Scan Proof of Address?</h4>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="images/photo/poof-address.png"
                                alt="How to scan Id?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  You can scan your document using your camera or upload it manually from your device by tapping on gallery icon.

                                </p>
                              </div>
                            </div>
                          </div>

                        </div>
                        <hr className="hrcss" />
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <h4 className="mb-4 mt-2">What to avoid?</h4>
                        </div>
                        <div
                          className="row justify-content-center"
                          bis_skin_checked={1}
                        >
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="images/photo/scanid4.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please avoid flash or glares on the document .
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="images/photo/scanid6.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please avoid shadows over on the document .
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="images/photo/scanid3.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please make sure your details aren't blurry
                                </p>
                              </div>
                            </div>
                          </div>
                          {/* <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="images/photo/scanid3.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text mb-4">
                                  Please make sure your details aren't blurry.
                                </p>
                              </div>
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-4 col-lg-4"
                            bis_skin_checked={1}
                          >
                            <div className="card cardcss" bis_skin_checked={1}>
                              <img
                                className="card-img-top"
                                src="images/photo/scanid5.png"
                                alt=" What to avoid?"
                              />
                              <div className="card-body" bis_skin_checked={1}>
                                <p className="card-text">
                                  Please make sure you are not cropping or
                                  skewing the ID.
                                </p>
                              </div>
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <NavLink
                        to="/liveness-check"
                        type="button"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="mt-5 sofax-default-btn pill sofax-header-btn text-whitee"
                        style={{
                          background: "#6c757d",
                          color: "white",
                          fontWeight: "bold",
                          height: "40px",
                          width: "200px",
                          fontSize: "24px",
                          padding: "8px",
                          borderRadius: "20px",
                        }}
                        bis_skin_checked={1}
                      >
                        Back
                      </NavLink>
                      <NavLink
                        to="/phone-verification"
                        type="button"
                        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                        className="mt-5 ms-2 sofax-default-btn pill sofax-header-btn text-whitee"
                        style={{
                          background: "#ffcc29",
                          color: "black",
                          fontWeight: "bold",
                          height: "40px",
                          width: "200px",
                          fontSize: "24px",
                          padding: "8px",
                          borderRadius: "20px",


                        }}
                        bis_skin_checked={1}
                      >
                        Next
                      </NavLink>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <CtaSection />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProofOfAddress;
